import React from 'react'
import { ImageIcon, Upload } from 'lucide-react'
import { Button } from 'components/ui/button'

interface LocationImagesEmptyStateProps {
	/**
	 * Opens the upload wizard. Previously this component embedded the uploader
	 * and handed back already-uploaded files; the wizard owns that flow now, so
	 * the empty state only has to ask for it.
	 */
	onUploadClick: () => void
}

const LocationImagesEmptyState: React.FC<LocationImagesEmptyStateProps> = ({ onUploadClick }) => {
	return (
		<div className="mx-auto flex max-w-2xl flex-col items-center rounded-xl border border-border bg-white px-6 py-10 text-center">
			<div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
				<ImageIcon className="h-5 w-5" />
			</div>

			<h3 className="mb-2 text-lg font-semibold text-foreground">No Images Yet</h3>

			<p className="mb-6 max-w-md text-sm text-muted-foreground">
				Upload photos to showcase the site visually. Images help your team quickly understand
				the space and track progress.
			</p>

			<Button type="button" variant="primary" onClick={onUploadClick}>
				<span className="flex items-center gap-2">
					<Upload className="h-4 w-4" />
					Upload Images
				</span>
			</Button>

			<div className="mt-8 w-full rounded-lg border border-amber-200 bg-amber-50 p-4 text-left text-sm text-amber-900">
				<h4 className="mb-1 text-sm font-semibold text-amber-900">💡 Tip</h4>
				<p className="m-0">
					Upload several images at once and add a note describing them, so the gallery and
					the activity feed stay in step.
				</p>
			</div>
		</div>
	)
}

export default LocationImagesEmptyState
